import React from 'react'
import FormFactory from '../../../../../components/form/form-factory'
import { If } from '../../../../../components/if/if'
import IFormPage from '../../../../../interfaces/form-page'
import { DeleteButton } from './styles'

type IProps = any & IFormPage

const CategoryForm = ({
  dataForm,
  onSubmit,
  initialFormData,
  onDelete,
}: IProps) => (
  <>
    <FormFactory
      data={dataForm}
      onSubmit={onSubmit}
      initialData={initialFormData}
    />

    <If condition={initialFormData.id}>
      <DeleteButton onClick={() => onDelete(initialFormData.id)}>
        Remover
      </DeleteButton>
    </If>
  </>
)

export default CategoryForm
